/*eslint-disable*/
export default address => {
	$(document).ready(() => {
		let $address = $(address)
		let $editAddressBtn = $address.find('.edit-address-link')[0]
		let $editAddressContainer = $address.find(`.account-page-address-book_edit-address`)
		let $editAddressCancelBtn= $address.find(`.cancel-address-edit`)[0]

    $editAddressBtn.addEventListener('click', (e) => {
      if ($editAddressContainer.hasClass('active')) {
        console.log("already active")
      } else {
        console.log("now active")
        $editAddressContainer.addClass('active')
      }
    })
    
    $editAddressCancelBtn.addEventListener('click', (e) => {
      if ($editAddressContainer.hasClass('active')) {
        $editAddressContainer.removeClass('active')
        console.log("removing")
      }
    })
  })
}


// WEBPACK FOOTER //
// ./src/scripts/components/account-address.js